import { LayoutType } from '../hooks/useLayout';

export interface LayoutConfig {
  type: LayoutType;
  showHeader?: boolean;
  showFooter?: boolean;
  showSidebar?: boolean;
  customStyles?: string;
}

export const layoutConfigs: Record<string, LayoutConfig> = {
  default: {
    type: 'default',
    showHeader: true,
    showFooter: true,
    showSidebar: false,
  },
  simple: {
    type: 'simple',
    showHeader: false,
    showFooter: true,
    showSidebar: false,
  },
  dashboard: {
    type: 'dashboard',
    showHeader: true,
    showFooter: true,
    showSidebar: true,
  },
  auth: {
    type: 'auth',
    showHeader: true,
    showFooter: true,
    showSidebar: false,
  },
  none: {
    type: 'none',
    showHeader: false,
    showFooter: false,
    showSidebar: false,
  },
} as const;

// Cấu hình layout cho từng route
export const pathConfigs: Record<string, LayoutConfig> = {
  // Dashboard routes
  '/': {
    type: 'default',
    showHeader: true,
    showFooter: true,
    showSidebar: false,
  },

  '/dashboard': {
    type: 'dashboard',
    showHeader: true,
    showFooter: false,
    showSidebar: true,
  },

  // Auth routes
  '/auth': {
    type: 'auth',
    showHeader: true,
    showFooter: true,
    showSidebar: false,
  },

  // API routes (no layout)
  '/api': {
    type: 'none',
    showHeader: false,
    showFooter: false,
    showSidebar: false,
  },
};

// Helper functions
export const getLayoutConfig = (path: string, layout?: string): LayoutConfig => {
  if (layout && layoutConfigs[layout]) {
    return layoutConfigs[layout];
  }

  // Remove query parameters and hash
  const cleanPath = path.split('?')[0].split('#')[0];

  // Check for exact match first
  if (pathConfigs[cleanPath]) {
    return pathConfigs[cleanPath];
  }

  // Check for dynamic routes (e.g., /dashboard/[id])
  const dynamicRoutes = Object.keys(pathConfigs).filter(key => key.includes('['));
  const firstSegment = cleanPath.split('/').slice(0, 2).join('/');

  for (const route of dynamicRoutes) {
    const pattern = route.replace(/\[.*?\]/g, '[^/]+');
    const regex = new RegExp(`^${pattern}$`);
    if (regex.test(cleanPath)) {
      return pathConfigs[route];
    }
  }

  return pathConfigs[firstSegment] || pathConfigs[`/${firstSegment}`] || pathConfigs['/'];
};

export const getLayoutType = (path: string): LayoutType => {
  return getLayoutConfig(path).type;
};
